import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Box
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';

const AccountTypeSelector = ({ open, onSelect, onClose, googleData }) => {
  const [accountType, setAccountType] = useState('');

  const handleSubmit = () => {
    if (accountType) {
      onSelect(accountType);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ textAlign: 'center' }}>
        Complete Your Registration
      </DialogTitle>
      <DialogContent>
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          Welcome! Please select your account type to continue:
        </Typography>
        <RadioGroup
          value={accountType}
          onChange={(e) => setAccountType(e.target.value)}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box
              sx={{
                border: '1px solid',
                borderColor: accountType === 'individual' ? 'primary.main' : 'grey.300',
                borderRadius: 1,
                p: 2,
                cursor: 'pointer',
                '&:hover': { bgcolor: 'grey.50' }
              }}
              onClick={() => setAccountType('individual')}
            >
              <FormControlLabel
                value="individual"
                control={<Radio />}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PersonIcon color={accountType === 'individual' ? 'primary' : 'action'} />
                    <Box>
                      <Typography variant="subtitle1">Individual Account</Typography>
                      <Typography variant="body2" color="text.secondary">
                        For personal use and individual assessments
                      </Typography>
                    </Box>
                  </Box>
                }
              />
            </Box>

            <Box
              sx={{
                border: '1px solid',
                borderColor: accountType === 'corporate' ? 'primary.main' : 'grey.300',
                borderRadius: 1,
                p: 2,
                cursor: 'pointer',
                '&:hover': { bgcolor: 'grey.50' }
              }}
              onClick={() => setAccountType('corporate')}
            >
              <FormControlLabel
                value="corporate"
                control={<Radio />}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <BusinessIcon color={accountType === 'corporate' ? 'primary' : 'action'} />
                    <Box>
                      <Typography variant="subtitle1">Corporate Account</Typography>
                      <Typography variant="body2" color="text.secondary">
                        For team members and corporate use
                      </Typography>
                    </Box>
                  </Box>
                }
              />
            </Box>
          </Box>
        </RadioGroup>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!accountType}
        >
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AccountTypeSelector; 